module.exports = __webpack_public_path__ + "img/25.0e9e7322.jpg";